export default __webpack_public_path__ + "static/media/Banner-Reclamos.0f3ed57e.png";